import { render, staticRenderFns } from "./DeletedPermanentlyReport.vue?vue&type=template&id=ecea99c6&scoped=true"
import script from "./DeletedPermanentlyReport.vue?vue&type=script&lang=js"
export * from "./DeletedPermanentlyReport.vue?vue&type=script&lang=js"
import style0 from "./DeletedPermanentlyReport.vue?vue&type=style&index=0&id=ecea99c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea99c6",
  null
  
)

export default component.exports